export default "/profile/images/human-sit.svg?49a3f2af7c3042e1ecd9665fe17615a2";